import React from 'react';
import { useTranslation } from 'react-i18next';
import { GridColDef } from '@mui/x-data-grid';
import { Client } from '@/types/client';
import Table from '@/components/molecules/section/Table';
import Container from '@/components/molecules/section/Container';

const View: React.FC<{ client: Client }> = ({ client }) => {
  const { t } = useTranslation();

  const columns: GridColDef[] = [
    { field: 'code', headerName: t('client.promo_code.code') },
    { field: 'currency', headerName: t('client.promo_code.currency') },
    { field: 'amount', headerName: t('client.promo_code.amount') },
    { field: 'discountPercent', headerName: t('client.promo_code.discount') },
    { field: 'orderNumber', headerName: t('client.promo_code.order_number') },
    { field: 'status', headerName: t('client.promo_code.code_status') },
  ];

  const rows = client.promoCodes.map((promo, index) => ({
    ...promo,
    code: promo.code || '-',
    id: index,
  }));

  return (
    <Container
      title={t('client.promo_code.title')}
      actions={[]}
      testId="promo_code"
    >
      <Table
        rows={rows}
        columns={columns}
        loading={false}
        table={{ kind: 'Table' }}
      />
    </Container>
  );
};

export default View;
